import React from 'react';
import PropTypes from 'prop-types';
import {
    openMopinionWidget,
    languageFeedbackForm,
    paynovaFeedbackForm,
    automaticSuggestionFeedbackForm,
    isEnabled
} from './mopinion-loader';

export const MopinionButton = ({ formKey, text, className }) => {
    return isEnabled() ? (
        <button
            className={className}
            onClick={() => openMopinionWidget(formKey)}>
            {text}
        </button>
    ) : null;
};

MopinionButton.propTypes = {
    formKey: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
};

export const MopinionLanguageFeedbackButton = ({ text, className }) => (
    <MopinionButton
        text={text}
        className={className}
        formKey={languageFeedbackForm}
    />
);

MopinionLanguageFeedbackButton.propTypes = {
    text: PropTypes.string.isRequired
};

export const MopinionPaynovaFeedbackButton = ({ text, className }) => (
    <MopinionButton
        text={text}
        className={className}
        formKey={paynovaFeedbackForm}
    />
);

MopinionLanguageFeedbackButton.propTypes = {
    text: PropTypes.string.isRequired
};

export const MopinionAutomaticSuggestionFeedbackButton = ({
    text,
    className
}) => (
    <MopinionButton
        text={text}
        className={className}
        formKey={automaticSuggestionFeedbackForm}
    />
);

MopinionAutomaticSuggestionFeedbackButton.propTypes = {
    text: PropTypes.string.isRequired
};
